var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 6c0 1.3-.84 2.41-2 2.82-.31.12-.65.18-1 .18s-.69-.06-1-.18c-1.16-.41-2-1.52-2-2.82 0-1.65 1.35-3 3-3s3 1.35 3 3zm7 9v11c0 1.65-1.35 3-3 3h-14c-1.65 0-3-1.35-3-3v-11c0-1.65 1.35-3 3-3h6v-1.1c.32.07.66.1 1 .1s.68-.03 1-.1v1.1h6c1.65 0 3 1.35 3 3zm-14 4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm7.8 2.9c-.33-.44-.96-.53-1.4-.2-.93.7-1.9.8-2.4.8-1.16 0-2-.5-2.4-.8-.44-.33-1.07-.24-1.4.2s-.24 1.07.2 1.4c.6.45 1.86 1.2 3.6 1.2.75 0 2.21-.16 3.6-1.2.44-.33.53-.96.2-1.4zm1.7-4.4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5zm-17.5-2c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2zm24 0v9c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.aca0398e0cd9075f29b645c26d99bafb.svg";
export { ForwardRef as ReactComponent };